import React, { Component } from 'react';
import SvgIcon from 'SvgIcon';

export default class Pagination extends Component {
  constructor(props) {
    super(props);
  }
  pageChange = (page) => {
    if (page == 0) return;
    let { current, total, pageSize } = this.props;
    if (cb.utils.isEmpty(total)) total = 0;
    if (cb.utils.isEmpty(current)) current = 0;
    if (cb.utils.isEmpty(pageSize)) pageSize = 0;
    let pageCount = pageSize != 0 ? Math.ceil(total / pageSize) : 0;
    if (page > pageCount) return;
    if (this.props.onChange)
      this.props.onChange(page);
    this.setState({ 'current': page });
  }
  onChange = (type) => {
    const { current } = this.props;
    let page = current;
    if (type == 'pre') {
      page = current - 3;
    } else {
      page = current + 3;
    }
    if (this.props.onChange) this.props.onChange(page);
  }
  getPagination = (current, pageCount) => {
    let controls = [];
    if (pageCount <= 7) {
      for (var i = 1; i <= pageCount; i++) {
        let index = i;
        controls.push(
          <li title={i} onClick={() => this.pageChange(index)} className={current == i ? "yxy_pagination_item yxy_pagination_item_active" : "yxy_pagination_item"}><a>{i}</a></li>
        )
      }
    } else {
      let showPre = false, showNext = false;
      if (current >= 4 || current > pageCount - 3) showPre = true;
      if ((showPre && current <= pageCount - 3) || current < 4) showNext = true;
      for (var i = 1; i <= 7; i++) {
        let index = i;
        if ((index == 2 && showPre) || (index == 6 && showNext)) {
          controls.push(
            <li onClick={() => this.onChange((index == 2 && showPre) ? 'pre' : 'next')} className={"yxy_pagination_item"}>
              <a><SvgIcon type="gengduo2" /></a>
            </li>
          )
        } else {
          let cIndex = index;
          if (index == 7) cIndex = pageCount;
          if (showPre && showNext) {
            if (index == 3) cIndex = current - 1;
            if (index == 4) cIndex = current;
            if (index == 5) cIndex = current + 1;
          } else if (showPre && !showNext) {
            if (index != 1) cIndex = pageCount - (7 - index);
          } else if (!showPre && showNext) {
            if (index != pageCount) cIndex = index;
          }
          controls.push(
            <li onClick={() => this.pageChange(cIndex)} className={current == cIndex ? "yxy_pagination_item yxy_pagination_item_active" : "yxy_pagination_item"}><a>{cIndex}</a></li>
          )
        }
      }
    }
    return (
      <ul className="yxy_pagination_list">{controls}</ul>
    )
  }
  render() {
    let { current, total, pageSize } = this.props;
    if (cb.utils.isEmpty(total)) total = 0;
    if (cb.utils.isEmpty(current)) current = 0;
    if (cb.utils.isEmpty(pageSize)) pageSize = 0;
    let pageCount = pageSize != 0 ? Math.ceil(total / pageSize) : 0;

    return (
      <div className="yxy_web_pagination">
        <span className={`${current == 1 ? 'pagination_first disabled' : 'pagination_first'}`}
          onClick={() => this.pageChange(current - 1)}><SvgIcon type={`${current == 1 ? 'left-disabled' : 'left'}`} /></span>
        {this.getPagination(current, pageCount)}
        <span className={`${current == pageCount ? 'pagination_last disabled' : 'pagination_last'}`}
          onClick={() => this.pageChange(current + 1)}>
          <SvgIcon type={`${current == pageCount ? 'right-disabled' : 'right'}`} />
        </span>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/pagination.jsx